import MultiSelectListPopover from './MultiSelectListPopover'

export default MultiSelectListPopover



// WEBPACK FOOTER //
// ./src/legacy/containers/Popovers/MultiSelectListPopover/index.js